import { ref, computed } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a2a4822"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "维度：", -1));
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  style: {
    "margin": "0",
    "padding-left": "20px"
  }
}, [/*#__PURE__*/_createElementVNode("li", null, "销售额=内购商品售卖价格总和(退款已扣)"), /*#__PURE__*/_createElementVNode("li", null, "总收入=销售额扣去分成后的实际收入(退款已扣)"), /*#__PURE__*/_createElementVNode("li", null, "总订单=支付成功的所有订单总数(不含退款订单数)"), /*#__PURE__*/_createElementVNode("li", null, "付费用户数=支付成功的用户总数"), /*#__PURE__*/_createElementVNode("li", null, "付费人均付费=销售额/付费用户数"), /*#__PURE__*/_createElementVNode("li", null, "人均客单价=销售额/总订单数"), /*#__PURE__*/_createElementVNode("li", null, "付费人均付费次数=总订单数/付费用户数"), /*#__PURE__*/_createElementVNode("li", null, "首次付费用户=在该应用内第一次完成下单支付的用户数"), /*#__PURE__*/_createElementVNode("li", null, "首次付费占比=首次付费用户/付费用户数"), /*#__PURE__*/_createElementVNode("li", null, "退费金额=退款成功的总金额"), /*#__PURE__*/_createElementVNode("li", null, "退费金额=退款成功的总订单数")], -1));
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
import FilterColumn from '@/views/revenueKanbanManage/components/FilterColumn.vue';
import { exportDimensionChart, selectDimensionChart } from '@/api/pay';
import { Empty, message } from 'ant-design-vue';
import { basicColumns } from '@/views/revenueKanbanManage/components/data';
import { getNode, reportEvent } from '@/common';
import { getIncomePermissionState } from '@/utils/incomePermission';
// 维度选项配置
export default /*#__PURE__*/_defineComponent({
  __name: 'TableContent',
  setup(__props, {
    expose
  }) {
    const permissionState = ref(getIncomePermissionState());
    const queryError = ref(false);
    let requestId = 0;
    const emptyDescription = computed(() => queryError.value ? '查询失败，请重试' : permissionState.value.allDenied ? '没有权限' : '暂无数据');
    // 维度选项接口定义
    const dimensionOptions = [{
      label: '支付渠道',
      value: 'pay_chnl',
      title: 'payChnl'
    }, {
      label: '包名',
      value: 'pkg',
      title: 'pkg'
    }, {
      label: '国家',
      value: 'country',
      title: 'country'
    }, {
      label: '应用版本',
      value: 'app_version',
      title: 'appVersion'
    }, {
      label: '商品信息',
      value: 'prod_id',
      title: 'prodName'
    }];
    // 响应式数据定义
    const dataSource = ref([]),
      // 表格数据源
      pageTotal = ref(0),
      // 总数据条数
      pageIndex = ref(1),
      // 当前页码
      pageSize = ref(10),
      // 每页显示条数
      columns = ref([
      // 表格列配置
      {
        title: '时间',
        dataIndex: 'paymentDate',
        key: 'paymentDate',
        sorter: true
      }, {
        title: '应用名',
        dataIndex: 'appName',
        key: 'appName'
      }]),
      dimensionList = ref([]),
      // 选中的维度列表
      dimensionTitleList = ref([]),
      // 维度标题列表
      indexList = ref([]),
      // 指标列表
      searchForm = ref({}),
      // 搜索表单数据
      loading = ref(false),
      // 加载状态
      exportLoading = ref(false),
      // 导出加载状态
      // 排序相关状态
      dateSort = ref(null),
      usdSalesSort = ref(null),
      cnySalesSort = ref(null),
      usdRevenueSort = ref(null),
      cnyRevenueSort = ref(null);
    // 方法定义
    // 获取列配置
    const getColumn = col => {
        let arr = [];
        col.list.forEach(item => {
          arr = [...arr, ...item.value];
        });
        indexList.value = arr;
        changeColumns();
      },
      // 分页变化处理
      currentPageSizeChange = (page, pageS) => {
        pageIndex.value = page;
        pageSize.value = pageS;
        getData();
      },
      // 获取表格数据
      getData = async (searchObj = {}) => {
        var _Object$keys;
        const currentRequest = ++requestId;
        const startTime = new Date().getTime();
        if ((_Object$keys = Object.keys(searchObj)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
          searchForm.value = searchObj;
        }
        // 构建请求参数
        let params = {
          pageNum: pageIndex.value,
          pageSize: pageSize.value,
          dimensionList: ['appName', ...dimensionList.value]
        };
        // 添加排序参数
        if (dateSort.value !== null) params = {
          ...params,
          dateSort: dateSort.value
        };
        if (usdSalesSort.value !== null) params = {
          ...params,
          usdSalesSort: usdSalesSort.value
        };
        if (cnySalesSort.value !== null) params = {
          ...params,
          cnySalesSort: cnySalesSort.value
        };
        if (usdRevenueSort.value !== null) params = {
          ...params,
          usdRevenueSort: usdRevenueSort.value
        };
        if (cnyRevenueSort.value !== null) params = {
          ...params,
          cnyRevenueSort: cnyRevenueSort.value
        };
        // 添加搜索条件
        Object.keys(searchForm.value).forEach(item => {
          var _searchForm$value$ite;
          if (searchForm.value[item] && (_searchForm$value$ite = searchForm.value[item]) !== null && _searchForm$value$ite !== void 0 && _searchForm$value$ite.length) {
            params = {
              ...params,
              [item]: searchForm.value[item]
            };
          }
        });
        loading.value = true;
        permissionState.value = getIncomePermissionState();
        queryError.value = false;
        dataSource.value = [];
        pageTotal.value = 0;
        const requestedIds = [...(params.dbtIdList || [])];
        try {
          const response = await selectDimensionChart(params);
          if (currentRequest !== requestId) return;
          const {
            data,
            code,
            count,
            noPermissionDbtIds
          } = response;
          if (code === '0') {
            dataSource.value = data || [];
            pageTotal.value = count;
            permissionState.value = getIncomePermissionState(requestedIds, noPermissionDbtIds);
            // 上报搜索成功事件
            reportEvent({
              eventName: '_search',
              properties: {
                ui_name: '收入报表搜索',
                app_name: '',
                return_duration: (new Date().getTime() - startTime) / 1000,
                query_status: 'succeed'
              }
            });
          } else {
            queryError.value = true;
            // 上报搜索失败事件
            reportEvent({
              eventName: '_search',
              properties: {
                ui_name: '收入报表搜索',
                app_name: '',
                return_duration: (new Date().getTime() - startTime) / 1000,
                query_status: 'failed'
              }
            });
          }
        } catch (e) {
          if (currentRequest !== requestId) return;
          queryError.value = true;
          // 上报搜索异常事件
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '收入报表搜索',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'failed'
            }
          });
        } finally {
          if (currentRequest === requestId) loading.value = false;
        }
      },
      // 搜索数据
      searchData = (searchObj = {}) => {
        pageIndex.value = 1;
        getData(searchObj);
      },
      // 导出Excel
      exportExcel = async () => {
        var _dataSource$value, _columns$value;
        // 上报导出事件
        reportEvent({
          eventName: 'element_use',
          properties: {
            ui_name: '收入报表',
            element_name: '导出'
          }
        });
        if (!((_dataSource$value = dataSource.value) !== null && _dataSource$value !== void 0 && _dataSource$value.length)) return false;
        // 构建导出参数
        let params = {
          pageNum: pageIndex.value,
          pageSize: pageSize.value,
          dimensionList: ['appName', ...dimensionList.value]
        };
        if (dateSort.value !== null) {
          params = {
            ...params,
            dateSort: dateSort.value
          };
        }
        // 添加搜索条件
        Object.keys(searchForm.value).forEach(item => {
          var _searchForm$value$ite2;
          if (searchForm.value[item] && (_searchForm$value$ite2 = searchForm.value[item]) !== null && _searchForm$value$ite2 !== void 0 && _searchForm$value$ite2.length) {
            params = {
              ...params,
              [item]: searchForm.value[item]
            };
          }
        });
        // 构建指标映射
        let indicatorsMap = {};
        (_columns$value = columns.value) === null || _columns$value === void 0 || _columns$value.map(item => {
          return indicatorsMap = {
            ...indicatorsMap,
            [item.dataIndex]: item.title
          };
        });
        params = {
          ...params,
          indicatorsMap
        };
        // 添加排序参数
        if (dateSort.value !== null) params = {
          ...params,
          dateSort: dateSort.value
        };
        if (usdSalesSort.value !== null) params = {
          ...params,
          usdSalesSort: usdSalesSort.value
        };
        if (cnySalesSort.value !== null) params = {
          ...params,
          cnySalesSort: cnySalesSort.value
        };
        if (usdRevenueSort.value !== null) params = {
          ...params,
          usdRevenueSort: usdRevenueSort.value
        };
        if (cnyRevenueSort.value !== null) params = {
          ...params,
          cnyRevenueSort: cnyRevenueSort.value
        };
        try {
          var _searchForm$value, _searchForm$value2;
          exportLoading.value = true;
          // 执行导出
          const blob = new Blob([await exportDimensionChart(params)], {
            type: 'application/vnd.ms-excel'
          });
          const url = window.URL.createObjectURL(blob);
          const downloadElement = document.createElement('a');
          downloadElement.href = url;
          downloadElement.download = `内购收入_${(_searchForm$value = searchForm.value) === null || _searchForm$value === void 0 ? void 0 : _searchForm$value.startDate}-${(_searchForm$value2 = searchForm.value) === null || _searchForm$value2 === void 0 ? void 0 : _searchForm$value2.endDate}.xlsx`;
          downloadElement.click();
          URL.revokeObjectURL(downloadElement.href);
          exportLoading.value = false;
          message.success('导出成功');
        } catch (e) {}
      },
      // 维度变化处理
      changeDime = () => {
        dimensionTitleList.value = dimensionOptions.filter(i => {
          var _dimensionList$value;
          return (_dimensionList$value = dimensionList.value) === null || _dimensionList$value === void 0 ? void 0 : _dimensionList$value.includes(i.value);
        }).map(i => i.title);
        pageIndex.value = 1;
        changeColumns();
        getData();
      },
      // 更新表格列配置
      changeColumns = () => {
        const arr = ['paymentDate', 'appName', ...dimensionTitleList.value, ...indexList.value];
        columns.value = basicColumns.filter(item => arr.includes(item.dataIndex));
      },
      // 表格排序变化处理
      changeSort = (pagination, filters, sorter) => {
        // 重置所有排序状态
        dateSort.value = null;
        usdSalesSort.value = null;
        cnySalesSort.value = null;
        usdRevenueSort.value = null;
        cnyRevenueSort.value = null;
        // 根据排序列设置对应的排序状态
        switch (sorter.columnKey) {
          case 'paymentDate':
            dateSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          case 'usdSales':
            usdSalesSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          case 'cnySales':
            cnySalesSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          case 'usdRevenue':
            usdRevenueSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          case 'cnyRevenue':
            cnyRevenueSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          default:
            break;
        }
        pageIndex.value = 1;
        getData();
      };
    // 对外暴露方法
    expose({
      searchData,
      permissionState
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_empty = _resolveComponent("a-empty");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_a_select, {
        placeholder: "选择维度",
        options: dimensionOptions,
        value: dimensionList.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => dimensionList.value = $event),
        mode: "multiple",
        "max-tag-count": 2,
        onChange: changeDime,
        getPopupContainer: _unref(getNode)
      }, null, 8, ["value", "getPopupContainer"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_tooltip, null, {
        title: _withCtx(() => [_hoisted_6]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "questionMark",
          "class-name": "market-icon"
        })]),
        _: 1
      }), _createVNode(FilterColumn, {
        onGetColumn: getColumn
      }), _createVNode(_component_a_button, {
        type: "primary",
        class: "export-btn",
        onClick: exportExcel,
        loading: exportLoading.value
      }, {
        default: _withCtx(() => [_createTextVNode("导出")]),
        _: 1
      }, 8, ["loading"])])]), _createVNode(_component_a_table, {
        columns: columns.value,
        "data-source": dataSource.value,
        bordered: "",
        scroll: {
          x: 150 * columns.value.length
        },
        pagination: false,
        loading: loading.value,
        onChange: changeSort
      }, {
        emptyText: _withCtx(() => [_createVNode(_component_a_empty, {
          image: _unref(Empty).PRESENTED_IMAGE_SIMPLE,
          description: loading.value ? '加载中' : _unref(emptyDescription)
        }, null, 8, ["image", "description"])]),
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _ref;
          return [column.dataIndex === 'firstBuyerRatio' ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString((_ref = (record === null || record === void 0 ? void 0 : record.firstBuyerRatio) * 100) === null || _ref === void 0 ? void 0 : _ref.toFixed(2)) + "%", 1)) : _createCommentVNode("", true), column.dataIndex === 'prodName' ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(record !== null && record !== void 0 && record.prodName ? record === null || record === void 0 ? void 0 : record.prodName : record === null || record === void 0 ? void 0 : record.sku), 1)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "data-source", "scroll", "loading"]), _createVNode(_component_a_pagination, {
        total: pageTotal.value,
        current: pageIndex.value,
        "onUpdate:current": _cache[1] || (_cache[1] = $event => pageIndex.value = $event),
        "show-size-changer": "",
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[2] || (_cache[2] = $event => pageSize.value = $event),
        onChange: currentPageSizeChange
      }, null, 8, ["total", "current", "page-size"])]);
    };
  }
});